module.exports = __webpack_public_path__ + "static/media/position-icon.5a72dfb2.svg";